import React from "react";
import PropTypes from "prop-types";

// GitHub language colors (most common)
const langColors = {
  JavaScript: "#f1e05a",
  TypeScript: "#3178c6",
  Python: "#3572A5",
  Java: "#b07219",
  "C++": "#f34b7d",
  C: "#555555",
  "C#": "#178600",
  Go: "#00ADD8",
  Rust: "#dea584",
  Ruby: "#701516",
  PHP: "#4F5D95",
  Swift: "#F05138",
  Kotlin: "#A97BFF",
  Dart: "#00B4AB",
  HTML: "#e34c26",
  CSS: "#563d7c",
  Shell: "#89e051",
  Lua: "#000080",
  Scala: "#c22d40",
  R: "#198CE7",
  Vue: "#41b883",
  Svelte: "#ff3e00",
};

const RepoItem = ({ repo }) => {
  const langColor = langColors[repo.language] || "#8888a0";

  return (
    <a
      href={repo.html_url}
      target="_blank"
      rel="noopener noreferrer"
      className="repo-card-link"
    >
      <div className="repo-card">
        <div className="repo-card-header">
          <span className="repo-card-icon">
            <i className="fas fa-book" />
          </span>
          <h3 className="repo-card-name">{repo.name}</h3>
        </div>

        {repo.description && (
          <p className="repo-card-desc">{repo.description}</p>
        )}

        <div className="repo-card-meta">
          {repo.language && (
            <span className="repo-meta-item">
              <span
                className="lang-dot"
                style={{ backgroundColor: langColor }}
              />
              {repo.language}
            </span>
          )}
          <span className="repo-meta-item">
            <i className="fas fa-star" />
            {repo.stargazers_count.toLocaleString()}
          </span>
          <span className="repo-meta-item">
            <i className="fas fa-code-branch" />
            {repo.forks_count.toLocaleString()}
          </span>
        </div>
      </div>
    </a>
  );
};

RepoItem.propTypes = {
  repo: PropTypes.object.isRequired,
};

export default RepoItem;
